// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

export default function BlockContent() {
  const { translate } = useLocales();
  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 150 }} />

      <Box>
        <Typography gutterBottom variant="h5" sx={{ fontSize: '14px !important', color: '#fff' }}>
          {translate('drop_or_select')}
        </Typography>

        <Typography variant="body2" sx={{ color: '#a8a8a8', fontSize: '12px !important' }}>
          {/* Drop files here or click&nbsp;
          <Typography
            variant="body2"
            component="span"
            sx={{ color: 'primary.main', textDecoration: 'underline', fontSize: '12px !important' }}
          >
            browse
          </Typography>
          &nbsp;thorough your machine */}
          {translate('drop_files_here')}
        </Typography>
      </Box>
    </Stack>
  );
}
